import {z} from 'zod';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {CreateTaskRequestBodySchema} from '@dms/api/core';
import {TaskPriorityEnumSchema, TaskTypeEnumSchema} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {getApiDateString} from 'shared/web';

import type {TaskForm} from '../../types/TaskForm';

const takeFirst = (v: unknown) => (Array.isArray(v) ? v[0] : v);
const takeFirstField = z.union([z.string(), z.array(z.string())]).transform(takeFirst);

// The date FormField stores a Date object in form state, while values loaded
// from the API are strings. Normalize Date to the API date string format.
const dueDateField = z.union([z.string(), z.date().transform(getApiDateString)]).nullable();

export const zodTaskFormSchema = CreateTaskRequestBodySchema.extend({
  title: z.string().nonempty().max(255).nullable(),
  priority: takeFirstField.pipe(TaskPriorityEnumSchema),
  type: takeFirstField.pipe(TaskTypeEnumSchema),
  dueDate: dueDateField,
}).superRefine((data, ctx) => {
  if (isNotNilOrEmpty(data.dueFrom) || isNotNilOrEmpty(data.dueTo)) {
    if (!isNotNilOrEmpty(data.dueDate)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['dueDate'],
        message: i18n.t('errors.field_is_required'),
      });
    }
  }

  if (isNotNilOrEmpty(data.dueFrom)) {
    if (!isNotNilOrEmpty(data.dueTo)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['dueTo'],
        message: i18n.t('errors.field_is_required'),
      });
    } else if (data.dueFrom === data.dueTo) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['dueTo'],
        message: i18n.t('entity.task.dueToNotSameTime'),
      });
    }
  }
}) as z.ZodSchema<TaskForm>;
